import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './PageContentWrapper.scss';

const PageContentWrapper = ({
  children, isRtl, isWithPadding, isWithHeader, headerChildren,
}) => {
  const classes = classNames({
    'page-content-wrapper': true,
    'page-content-wrapper--rtl': isRtl,
    'page-content-wrapper--withPadding': isWithPadding,
    // 'page-content-wrapper--withHeader': isWithHeader,
  });
  return (
    <>
      {isWithHeader && (
        <header className="page-content-wrapper__header">
            {headerChildren}
        </header>
      )}
      <section className={classes}>
        {children}
      </section>
    </>
  );
};

PageContentWrapper.propTypes = {
  /** Children/ Elements */
  children: PropTypes.node,
  /** is right to left */
  isRtl: PropTypes.bool,
  /** is container with padding? */
  isWithPadding: PropTypes.bool,
};

PageContentWrapper.defaultProps = {
  children: <></>,
  isRtl: false,
  isWithPadding: false,
};

export default PageContentWrapper;
